import { LinkTokens } from './types';

export const link: LinkTokens = {
  css: {
    borderBottom: 'none',
  },
  variants: {
    isUnderlined: {
      false: {
        borderBottom: 'unset',
        textDecoration: 'unset',
      },
      true: {
        ':hover': {
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: 'neutrals.0',
          textDecoration: 'none',
        },
      },
    },
    type: {
      primary: {
        color: 'brandPrimary.1',
        borderColor: 'brandPrimary.1',
      },
      dotted: {
        color: 'brandPrimary.1',
        ',:hover': {
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textUnderlineOffset: '7px',
          lineHeight: 'bodies.base',
        },
        ':hover': {
          color: 'primary.70',
          borderBottom: 'none',
        },
      },
      legal: {
        color: 'neutrals.2',
        fontSize: 'body.0',
        borderBottom: 'none',
        ':hover': {
          color: 'neutrals.0',
          borderColor: 'neutrals.0',
          textDecoration: 'none',
          borderBottom: '1px solid neutrals.0',
        },
      },
      legalUnderline: {
        color: 'neutrals.2',
        fontSize: 'body.0',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'neutrals.4',
        textDecoration: 'none',
        ':hover': {
          color: 'neutrals.0',
          borderColor: 'neutrals.0',
          borderBottomColor: 'neutrals.0',
          textDecoration: 'none',
        },
      },
    },
    disabled: {
      true: {
        color: 'neutrals.4',
        cursor: 'not-allowed',
        borderBottom: 'none',
        ':hover': {
          textDecoration: 'none',
        },
      },
    },
  },
};
